export default "__VITE_ASSET__BeMaieS$__"